import { jsx as _jsx } from "react/jsx-runtime";
import { getNiveisEscolaridade } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function NiveisEscolaridade() {
    return (_jsx(GridBase, { pagina: PAGINAS.NIVEIS_ESCOLARIDADE, paginaPermissao: FUNCIONALIDADES.NIVEIS_ESCOLARIDADE, rota: ROUTES.NIVEIS_ESCOLARIDADE, fetchData: function (str, _, pag) { return getNiveisEscolaridade(str, pag); }, columns: COLUNAS }));
}
